import { schedulingGet, schedulingPut, versionBody } from "./client";

export const BOOKING_HORIZON_PRESETS = [90, 120, 180];
export const SLOT_SEARCH_PRESETS = [30, 60, 90];
export const HORIZON_SLOT_SEARCH_GAP_DAYS = 7;
export const DEFAULT_SCHEDULING_SETTINGS = { bookingHorizonDays: 120, slotSearchDays: 90 };

/** Slot searches must end at least a week before the booking horizon. */
export function isSlotSearchAllowed(slotSearchDays, bookingHorizonDays) {
  return Number(slotSearchDays) + HORIZON_SLOT_SEARCH_GAP_DAYS <= Number(bookingHorizonDays);
}

export function getSchedulingSettings({ organizationRef }) {
  return schedulingGet("settings", { organizationRef });
}

export function updateSchedulingSettings({ organizationRef, bookingHorizonDays, slotSearchDays, expectedVersion }) {
  return schedulingPut("settings", {
    organizationRef,
    bookingHorizonDays,
    slotSearchDays,
    ...versionBody(expectedVersion),
  });
}
